"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schoolShortSchema = void 0;
const lingo2_models_1 = require("lingo2-models");
const zod_1 = require("zod");
const school_stats_1 = require("./school-stats");
exports.schoolShortSchema = zod_1.z.object({
  id: zod_1.z.string(),
  title: zod_1.z.string(),
  description: zod_1.z.string().optional(),
  short_description: zod_1.z.string().optional(),
  slug: zod_1.z.string(),
  status: zod_1.z.nativeEnum(lingo2_models_1.ESchoolStatus),
  head_cover_id: zod_1.z.string(),
  cover_id: zod_1.z.string(),
  rating: zod_1.z.number(),
  review_count: zod_1.z.number(),
  stats: school_stats_1.schoolStatsSchema,
  created_at: zod_1.z.number(),
  updated_at: zod_1.z.number(),
  deleted_at: zod_1.z.number().nullable()
});
